module.exports = __webpack_public_path__ + "assets/img/login-bg-repeat1.84094a03.png";